















































































import { defineComponent, PropType } from '@vue/composition-api';
import { useVModel, toRefs } from '@vueuse/core';
import { Address } from '@front-app/services/SharedModels';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { Spacing } from '../constants';
import { usePostalMask } from '../inputs/util';
import SimpleInputSection from './SimpleInputSection.vue';
import FormSection from './FormSection.vue';
import FormError from './FormError.vue';
import CountryPicker from '../inputs/CountryPicker.vue';
import RegionPicker from '../inputs/RegionPicker.vue';
import FormLabel from './FormLabel.vue';

export default defineComponent({
	components: {
		SimpleInputSection,
		FormSection,
		FormError,
		CountryPicker,
		RegionPicker,
		FormLabel,
	},
	props: {
		value: {
			type: Object as PropType<Address>,
			required: true,
		},
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.WIDE,
		},
		withCard: Boolean,
	},
	setup(props) {
		const data = toRefs(useVModel(props, 'value'));
		const postalMask = usePostalMask(data.country);
		return {
			...data,
			postalMask,
			SimpleCard,
		};
	},
});
